import { makeStyles } from "tss-react/mui";

export const useCreateCustomDataProjectDialogStyles = makeStyles()(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    overflowY: "auto",
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
  },
  input: {
    "& input": {
      paddingTop: 0,
      backgroundColor: "var(--bg-white)",
      color: "var(--color-neutral-800)",
      borderColor: "grey",
      paddingLeft: 0,
    },
  },
  formItem: {
    display: "flex",
    width: "100%",
    overflowY: "auto",
    flexDirection: "column",
  },
  label: {
    fontSize: 18,
    fontWeight: "bold",
  },
  actions: {
    display: "flex",
    gap: 24,
    justifyContent: "center",
    width: "100%",
    marginBottom: 24,
  },
  btnBack: {
    fontSize: "1rem",
    marginLeft: -12,
  },
  backIcon: {
    marginRight: 4,
  },
  spinner: {
    marginLeft: 10,
    width: "20px !important",
    height: "20px !important",
    color: "var(--color-secondary)",
  },
}));
